// Authentification + espace client — français.
const app = {
  common: {
    edit: 'modifier',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    save: 'Enregistrer',
    create: 'Créer',
    close: 'Fermer',
    delete: 'Supprimer',
    loading: 'Chargement…',
    working: '…',
    back: 'Retour',
    backHome: 'Retour à l’accueil',
    dash: '—',
    yes: 'Oui',
    no: 'Non'
  },

  field: {
    show: 'Afficher',
    hide: 'Masquer',
    showPassword: 'Afficher le mot de passe',
    hidePassword: 'Masquer le mot de passe'
  },

  errors: {
    email: 'Entre une adresse e-mail valide.',
    orderEmail: 'Entre l’adresse e-mail de ta commande.',
    password: 'Entre ton mot de passe.',
    passwordLength: 'Au moins 8 caractères.',
    passwordMismatch: 'Les mots de passe ne correspondent pas.',
    emailTaken: 'Cette adresse est déjà utilisée.',
    currentPassword: 'Entre ton mot de passe actuel.',
    network: 'Impossible de joindre le serveur. Vérifie qu’Apache est démarré.',
    http: status => `Erreur ${status}`,
    inactiveSub: 'Abonnement inactif.'
  },

  login: {
    title: 'Content de te revoir.',
    subtitle: 'Connecte-toi pour retrouver ton verrou, tes horaires et ton compteur de jours.',
    quote: 'Chaque jour tenu compte double.',
    caption: 'Ton espace',
    justSubscribed: 'Tu viens de t’abonner ?',
    claimLink: 'Première connexion',
    noAccount: 'Pas encore de compte ?',
    plansLink: 'Voir les formules',
    emailLabel: 'Adresse e-mail',
    emailPlaceholder: 'toi@exemple.fr',
    passLabel: 'Mot de passe',
    passPlaceholder: 'Ton mot de passe',
    forgot: 'Mot de passe oublié ?',
    forgotMsg: e => `Bonjour, j’ai oublié mon mot de passe SELFCNTRL.${e ? ' Mon e-mail : ' + e : ''}`,
    submit: 'Se connecter',
    submitting: 'Connexion…',
    stuck: 'Impossible de te connecter ?',
    stuckLink: 'Écris-nous sur WhatsApp'
  },

  register: {
    // Page d'inscription « caisse » (9 oct. 2026).
    steps: ['Compte', 'Paiement', 'Verrouiller'],
    eyebrow: 'Étape 1 sur 3 · environ 1 minute',
    pageTitle: 'Crée ton espace.',
    pageSub: 'Choisis une formule et un mot de passe. Le paiement suit, sur Stripe.',
    perDayMonthly: '≈ 0,33 $ par jour',
    perDayYearly: '≈ 0,14 $ par jour',
    sumTitle: 'Ta commande',
    sumIncl: 'Ce qui est inclus',
    sumItems: ['Tous tes appareils verrouillés', 'Impossible à retirer à 2 h du matin', 'Couvre-feux et blocages en plus', 'Du cashback chaque mois tenu', 'Un humain sur WhatsApp'],
    sumToday: 'À payer aujourd’hui',
    sumThen: p => p === 'yearly' ? 'Puis 49,99 $ par an. Résiliable à tout moment.' : 'Puis 9,99 $ par mois. Résiliable à tout moment.',
    sumGuarT: 'Remboursé 30 jours',
    sumGuarP: 'Remboursement intégral, sans justification. Et 100 $ en plus si tu arrives à contourner le verrou.',
    nextT: 'Et ensuite',
    next: ['Paiement sécurisé sur Stripe', 'Une installation guidée de 10 minutes', 'Ton compteur de jours démarre'],
    secure: 'Chiffré · Paiement par Stripe · Facturation discrète',
    terms: 'En continuant, tu acceptes les',
    termsLink: 'conditions',
    // Plus d'essai depuis le 26/09/2026 : les deux formules se paient tout de
    // suite, le titre ne promet donc rien de gratuit.
    title: 'Verrouille ce soir.',
    titleYear: 'Verrouille toute l’année.',
    subtitle: <>1 minute pour créer ton compte,<br />5 minutes pour installer ta protection.</>,
    quote: 'Ce que tu laisses derrière toi.',
    caption: 'Jour 0',
    haveAccount: 'Déjà un compte ?',
    loginLink: 'Se connecter',
    // Le montant réellement débité aujourd'hui, et ce qui rentre ensuite.
    // Plus d'essai depuis le 26/09/2026 : la carte est débitée à l'inscription.
    freeT: 'Total aujourd’hui : 9,99 $',
    freeS: 'Remboursé 30 jours — et sois payé pour tenir',
    // Affichés à la place des deux précédents quand la formule annuelle est
    // choisie.
    yearT: 'Total aujourd’hui : 49,99 $',
    yearS: '4,17 $ par mois, facturé à l’année — remboursé 30 jours',
    planGroup: 'Formule',
    monthly: 'Mensuel',
    monthlyPrice: '9,99 $',
    monthlyPer: '/ mois',
    yearly: 'Annuel',
    yearlyPrice: '49,99 $',
    yearlyPer: '/ an',
    // Prix de référence barré sur la formule annuelle : le coût RÉEL de douze
    // mois en mensuel (9,99 $ × 12), jamais un tarif inventé.
    yearlyWas: '120 $/an',
    // Badge « meilleur choix » sur l'annuel : on oriente vers l'année (moins
    // de résiliations, et aligné avec un produit de self-control où le bouton
    // « résilier » mensuel est lui-même une tentation).
    best: 'Meilleur choix',
    emailLabel: 'Adresse e-mail',
    emailPlaceholder: 'toi@exemple.fr',
    passLabel: 'Mot de passe',
    passPlaceholder: '8 caractères minimum',
    submit: 'Commencer',
    submitYear: 'Prendre l’année',
    submitting: 'Un instant…',
    // Bloc de réassurance SOUS le bouton (comme le concurrent) : le dernier
    // mot revient aux garanties, pas à un frein. Rien d'inventé ici — chaque
    // ligne existe déjà dans les CGV / la politique de remboursement.
    pay: 'Paiement sécurisé',
    // ⚠️ N'afficher Apple Pay / Google Pay QUE s'ils sont réellement activés
    // dans le tableau de bord Stripe : un logo de portefeuille promis puis
    // absent sur la page de paiement fait abandonner. Les cartes, elles, sont
    // toujours acceptées.
    brands: ['Apple Pay · Google Pay', 'Visa', 'Mastercard', 'Amex'],
    guar: [
      'Remboursé 30 jours, sans justification. Résiliable en un clic.',
      'Garantie zéro accès : tu contournes le blocage ? Remboursé, plus 100 $.',
      'Paiement SSL via Stripe. Ta carte ne touche jamais nos serveurs. Discret.'
    ],
    guarYear: [
      'Remboursé 30 jours, sans justification, sur simple demande.',
      'Garantie zéro accès : tu contournes le blocage ? Remboursé, plus 100 $.',
      'Paiement SSL via Stripe. Ta carte ne touche jamais nos serveurs. Discret.'
    ],
    // Preuve sociale, en tête du formulaire : la crédibilité avant l'offre.
    // Chiffres FOURNIS par l'exploitant — ne rien gonfler ici sans qu'il les
    // mette à jour, une preuve sociale invérifiable coûte plus qu'elle ne
    // rapporte.
    stats: [
      { n: '10 min', l: 'Pour verrouiller un appareil' },
      { n: '100 $', l: 'Si tu le contournes' },
      { n: '30 jours', l: 'Satisfait ou remboursé' }
    ],
    // Le détail du débit / remboursement est désormais porté par les
    // garanties sous le bouton : il ne reste ici que l'acceptation des CGV.
    note: 'En continuant, tu acceptes les ',
    noteLife: 'En continuant, tu acceptes les ',
    noteLink: 'conditions générales',
    fallbackName: 'moi'
  },

  claim: {
    title: 'Active ton espace.',
    subtitle: 'Tu viens de t’abonner. Choisis ton mot de passe et ton compte est prêt.',
    quote: 'La porte t’attend.',
    caption: 'Première connexion',
    havePassword: 'Tu as déjà un mot de passe ?',
    loginLink: 'Se connecter',
    emailLabel: 'E-mail de la commande',
    emailPlaceholder: 'toi@exemple.fr',
    emailHint: 'Celle que tu as utilisée au moment de l’achat.',
    passLabel: 'Choisis un mot de passe',
    passPlaceholder: 'Au moins 8 caractères',
    confirmLabel: 'Confirme le mot de passe',
    confirmPlaceholder: 'Ressaisis-le',
    submit: 'Activer mon espace',
    submitting: 'Activation…'
  },

  contactForm: {
    title: 'Écris-nous',
    lead: 'Sur WhatsApp. On répond en moins d’une heure, entre 9h et 23h.',
    waCta: 'Nous écrire sur WhatsApp',
    v2: { live: 'Une vraie personne répond', waS: 'Le plus rapide. Ton compte est joint au message, pas besoin d’expliquer qui tu es.' },
    waMsg: email => `Bonjour, j’ai besoin d’aide avec SELFCNTRL.${email ? ` Compte : ${email}` : ''}`,
    navLabel: 'Contact'
  },

  welcome: {
    title: 'C’est parti.',
    subtitle: 'Ton accès est actif. Il reste une chose à faire.',
    quote: 'Jour un.',
    caption: 'Le compteur démarre',
    problem: 'Un souci ?',
    write: 'Écris-nous',
    noPayment: `Aucun paiement détecté. Si tu viens de régler, patiente quelques
                secondes puis recharge la page.`,
    seePlans: 'Voir les formules',
    payment: 'Paiement',
    recorded: 'Enregistré',
    lock: 'Verrou',
    lockReady: 'Prêt à poser',
    lockActivating: 'Activation en cours…',
    nextReady: 'Prochaine étape : verrouiller tes appareils. Compte dix minutes, une seule fois.',
    nextWaiting: 'On attend la confirmation du paiement. Ça prend quelques secondes.',
    cta: 'Verrouiller mes appareils',

    helloT: 'Bienvenue parmi nous.',
    helloP: `Tu es des nôtres. Prends trois minutes pour le tutoriel d’abord : il
             montre chaque écran que tu vas voir, dans l’ordre. C’est ce qui
             sépare un téléphone verrouillé ce soir d’un abandon à l’étape deux.`,
    helloMeta: '3 parties · 19 étapes · captures réelles',
    ctaTutorial: 'Ouvrir le tutoriel',
    ctaSkip: 'Passer, aller à mon verrou'
  },

  // Coque de l'app (refonte du 9 oct. 2026).
  shell: {
    tabs: { overview: 'Aujourd’hui', protection: 'Verrou', sos: 'SOS', rank: 'Progrès', rewards: 'Récompenses', menu: 'Menu' },
    more: 'Profil et réglages',
    sections: { main: 'Principal', more: 'Plus' },
    hello: (n, h) => `${h < 5 ? 'Encore debout' : h < 18 ? 'Bonjour' : 'Bonsoir'}${n ? ', ' + n : ''}`,
    sosCta: 'SOS envie',
    sosSub: 'Un geste, au moment où ça monte',
    groups: { progress: 'Progression', help: 'Aide', account: 'Compte' }
  },

  dash: {
    nav: {
      overview: 'Vue d’ensemble',
      protection: 'Mon verrou',
      tutorial: 'Tutoriel',
      rank: 'Mon rang',
      goals: 'Objectifs',
      rewards: 'Récompenses',
      subscription: 'Abonnement',
      account: 'Mon compte',
      contact: 'Nous écrire',
      sos: 'SOS envie'
    },
    fallbackTitle: 'Mon espace',
    logout: 'Déconnexion',
    openMenu: 'Ouvrir le menu',
    closeMenu: 'Fermer le menu',
    dayShort: 'j',
    more: 'Plus',
    sub: {
      sos: 'La minute où ça monte',
      rewards: 'Tes CNTRL et tes cartes cadeaux',
      tutorial: 'Poser le verrou en dix minutes',
      goals: 'Ce que devient le temps rendu',
      subscription: 'Formule, paiement, factures',
      account: 'Nom, mot de passe, fuseau',
      contact: 'Une vraie réponse sous 24 h'
    },
    pending: n => `${n} appareil${n > 1 ? 's' : ''} à verrouiller`
  },



  calendar: {
    prev: 'Mois précédent',
    next: 'Mois suivant',
    held: n => n === 0 ? 'Rien de tenu ce mois-ci pour l’instant' : `${n} jour${n > 1 ? 's' : ''} tenu${n > 1 ? 's' : ''} ce mois-ci`
  },

  install: {
    title: 'Mets SELFCNTRL sur ton écran d’accueil',
    body: 'À un doigt de tes jours, de ton verrou et du SOS. Pas d’App Store, rien à télécharger.',
    bodyIos: 'Trois gestes dans Safari, et elle vit à côté de tes autres apps.',
    cta: 'Ajouter à l’écran d’accueil',
    // Version BARRE (tableau de bord) : une ligne, donc trois mots maximum.
    barT: 'Garde-la à portée de pouce',
    barCta: 'Ajouter',
    barHow: 'Comment',
    barClose: 'Masquer',
    ios1: 'Touche Partager, en bas de Safari',
    ios2: 'Choisis « Sur l’écran d’accueil »',
    ios3: 'Touche Ajouter. C’est tout.',
    doneT: 'Installée.',
    doneS: 'Retrouve SELFCNTRL sur ton écran d’accueil.'
  },

  sos: {
    breathK: 'Maintenant',
    breathT: 'Respire d’abord.',
    breathOn: 'Inspire… et souffle.',
    breathP: 'Une minute. Rien d’autre à faire. L’envie monte puis redescend — toujours.',
    breathCta: 'Lancer la minute',
    skip: 'Passer',
    stepK: (i, n) => `Étape ${i} sur ${n}`,
    steps: [
      { t: 'Lève-toi. Sors de la pièce.', p: 'Physiquement. Prends le téléphone s’il le faut, mais change de murs.' },
      { t: 'Bois un verre d’eau.', p: 'Froide si tu peux. Lentement.' },
      { t: 'Écris une ligne.', p: 'Ce que tu ressens, avec tes mots. Personne ne la lit.', write: true }
    ],
    notePh: 'Là, tout de suite, je…',
    next: 'Fait — suivant',
    stepsDone: 'Terminé',
    peopleK: 'Tu n’es pas seul',
    peopleT: 'Quelqu’un est réveillé.',
    peopleP: '#urge-sos sur le Discord existe pour cette minute précise. Dis-le à voix haute.',
    discordCta: 'Ouvrir #urge-sos',
    backHome: 'Retour à mon espace',
    slippedP: 'Si c’est déjà arrivé :'
  },

  status: {
    labels: {
      trialing: 'Essai en cours',
      active: 'Abonnement actif',
      past_due: 'Paiement en attente',
      canceled: 'Abonnement résilié',
      none: 'Aucun abonnement'
    },
    inactiveNote: 'Le filtrage est suspendu tant que l’abonnement est inactif.',
    seePlans: 'Voir les formules',
    noneTitle: 'Aucun appareil verrouillé',
    noneTrial: n => `Ton abonnement tourne (${n} jour${n > 1 ? 's' : ''} d’essai), mais rien n’est encore protégé. Compte dix minutes.`,
    noneNote: 'Ton abonnement tourne, mais rien n’est encore protégé. Compte dix minutes.',
    lockDevice: 'Verrouiller un appareil',
    onTitle: 'Verrou actif',
    onCount: n => `${n} appareil${n > 1 ? 's' : ''} verrouillé${n > 1 ? 's' : ''}`,
    onPending: n => ` · ${n} encore en attente`,
    onDone: '. Il n’y a plus de porte ouverte.'
  },

  rankBand: {
    kicker: 'Ton rang',
    days: n => <><b>{n}</b> jour{n > 1 ? 's' : ''} tenu{n > 1 ? 's' : ''}</>,
    toward: name => `Vers ${name}`,
    left: n => `${n} j restants`,
    seeLadder: 'Voir l’échelle'
  },

  rankSwiper: {
    day: n => `Jour ${n}`,
    reached: 'Atteint',
    now: 'Ton rang',
    inDays: n => `Dans ${n} jour${n > 1 ? 's' : ''}`,
    locked: 'Continue de tenir pour le débloquer.',
    prev: 'Rang précédent',
    next: 'Rang suivant'
  },

  ranks: {
    dechu: { name: 'Déchu', line: 'Le premier jour est le plus dur. Tu l’as commencé.' },
    eveille: { name: 'Éveillé', line: 'Le cerveau proteste. C’est le signe que ça marche.' },
    novice: { name: 'Novice', line: 'Une semaine. Le sommeil commence à revenir.' },
    gardien: { name: 'Gardien', line: 'Deux semaines. L’envie se fait plus rare et plus faible.' },
    sentinelle: { name: 'Sentinelle', line: 'Un mois. Les gens autour de toi le remarquent sans savoir pourquoi.' },
    seraphin: { name: 'Séraphin', line: 'Deux mois. Ce n’est plus un combat, c’est ton quotidien.' },
    archange: { name: 'Archange', line: 'Quatre mois. Tu ne comptes plus les jours de la même façon.' },
    elu: { name: 'Élu', line: 'Un an. Tu es devenu quelqu’un d’autre.' }
  },

  overview: {
    // Tant que rien n'est verrouillé, l'accueil s'ouvre sur CETTE carte.
    setup: {
      kicker: 'Première chose à faire',
      title: 'Verrouille ton premier appareil.',
      lead: 'Ton abonnement tourne, mais rien n’est encore protégé. Compte dix minutes — c’est tout le produit.',
      steps: ['Choisis l’appareil : iPhone, iPad, Mac ou Windows', 'Suis la vidéo, une étape à la fois', 'Scanne le code — le verrou est posé'],
      cta: 'Lancer le tutoriel',
      alt: 'J’ai déjà l’app',
      note: 'Ton compteur de jours démarre au premier appareil verrouillé.'
    },
    daysHeld: n => `jour${n > 1 ? 's' : ''} tenu${n > 1 ? 's' : ''}`,
    since: d => `Depuis le ${d}`,
    profiles: n => `Profil${n > 1 ? 's' : ''}`,
    devices: n => `Appareil${n > 1 ? 's' : ''}`,
    supervised: n => `Supervisé${n > 1 ? 's' : ''}`,
    coverage: 'Couverture',
    hello: name => `Salut ${name}`,
    thisWeek: 'Cette semaine',
    weekHint: n => n >= 7 ? 'Sept sur sept.' : `${n} des 7 derniers jours tenu${n > 1 ? 's' : ''}`,
    quick: 'Actions rapides',
    lockedDevices: 'Appareils verrouillés',
    stillOpen: n => `${n} appareil${n > 1 ? 's' : ''} encore ouvert${n > 1 ? 's' : ''} — `,
    lockIt: 'le verrouiller',
    blocked: {
      title: 'Requêtes bloquées',
      sub: n => `sur les ${n} derniers jours`,
      lead: 'Sur tes appareils filtrés. On compte tout ce qui est bloqué — y compris les pubs, traqueurs et scripts qui appellent ces sites tout seuls, sans que personne y aille.',
      empty: 'Aucune requête bloquée pour l’instant — dès qu’un appareil filtré tape sur un contenu interdit, ça compte ici.',
      unavailable: 'Les journaux Cloudflare sont momentanément indisponibles.',
      catsT: 'Ce qui a été bloqué',
      cats: {
        adult: 'Contenu adulte',
        gambling: 'Jeux d’argent',
        dating: 'Rencontres',
        social: 'Réseaux sociaux',
        gaming: 'Jeux',
        other: 'Autres'
      },
      today: 'aujourd’hui'
    }
  },

  installs: {
    title: 'Installations · 14 derniers jours',
    total: n => `${n} au total`,
    tooltip: n => `installation${n > 1 ? 's' : ''}`
  },

  protection: {
    title: 'Mon verrou',
    emptyLead: 'Crée ton profil de blocage pour commencer.',
    summary: (p, d, locked) =>
      `${p} profil${p > 1 ? 's' : ''} · ${d} appareil${d > 1 ? 's' : ''}` +
      (d ? ` · ${locked} verrouillé${locked > 1 ? 's' : ''}` : ''),
    addProfile: 'Ajouter un profil',
    nameLabel: 'Nom du profil',
    namePlaceholder: 'Mes appareils',
    creating: 'Création…',
    create: 'Créer',
    emptyT: 'Aucun profil pour l’instant',
    emptyS: 'Un profil réunit un niveau de filtrage, des couvre-feux et tes appareils.',
    emptyCta: 'Créer mon profil',
    firstT: 'Verrouille ton premier appareil.',
    firstP: 'Environ dix minutes. Choisis l’appareil, suis les étapes, et le filtre ne s’enlève plus sur un coup de tête.',
    firstCta: 'Verrouiller mon premier appareil',
    defaultName: 'Moi',
    ghostT: 'Ajouter un profil',
    ghostS: 'Un autre niveau, d’autres appareils.',
    abandon: name => `Abandonner ${name}`,
    stateOn: 'Verrou actif',
    stateOff: 'En préparation',
    filtering: 'Filtrage',
    strict: 'Strict',
    filteringHint: `Pornographie, nudité et thèmes adultes bloqués à la racine,
                    en continu, sur tous les appareils du profil.`,
    filteringNote: `Il n’y a pas de niveau plus faible : un verrou qu’on peut
                    desserrer n’est pas un verrou.`,
    devices: 'Appareils',
    noDevices: `Aucun appareil pour l’instant. Ils apparaissent ici tout seuls,
                une fois verrouillés.`,
    deviceNote: `Un appareil ne se retire pas d’un clic : le profil resterait
                 installé dessus. Il se détache en abandonnant le profil, avec
                 son délai de réflexion.`,
    locked: 'Verrouillé',
    pending: 'En attente',
    supervisedSuffix: ' · supervisé',
    active: 'Actif',
    inactive: 'Inactif',
    lastSeen: x => `vu il y a ${x}`,
    ago: { now: "à l'instant", m: 'min', h: 'h', d: 'j' },
    dirty: 'Modifications non appliquées',
    applying: 'Application…',
    ctaPending: 'Scanne le QR depuis l’appareil à verrouiller.',
    ctaDone: 'Tous les appareils sont verrouillés.',
    lock: 'Verrouiller',
    // Carte compacte (refonte)
    filterStrict: 'Filtrage strict',
    stProtected: 'Protégé',
    stToLock: 'À verrouiller',
    // Verrouillé, mais qui mérite un coup d'œil : le Guard se dit éteint, ou
    // plus une requête DNS depuis deux semaines (profil retiré à la main ?).
    stCheck: 'À vérifier',
    warnGuardOff: 'filtrage arrêté',
    stPartial: (n, tot) => `${n}/${tot} protégés`,
    stNoDevice: 'Aucun appareil',
    devicesLine: (n, locked) => `${n} appareil${n > 1 ? 's' : ''} · ${locked} verrouillé${locked > 1 ? 's' : ''}`,
    settings: 'Réglages',
    settingsHide: 'Masquer les réglages',
    lockDevice: 'Verrouiller un appareil',
    lockAnother: 'Verrouiller un autre appareil',
    v2: {
      allOn: 'Tout est verrouillé',
      partOn: 'Presque fini',
      noneOn: 'Pas encore protégé',
      countLine: (n, tot) => `${n} appareil${n > 1 ? 's' : ''} verrouillé${n > 1 ? 's' : ''} sur ${tot}`,
      addS: 'iPhone, iPad, Mac ou Windows · environ 10 min',
      paceT: 'Rythme de sevrage',
      paceS: 'Quels jours sont verrouillés, et comment ça se resserre',
      moreT: 'Bloquer plus',
      moreS: 'Jeux d’argent, rencontres, réseaux… et tes propres sites',
      cutsT: 'Coupures Internet',
      cutsS: 'Plus d’Internet du tout à certaines heures'
    }
  },

  blockMore: {
    label: 'Bloquer plus',
    none: 'Rien en plus',
    count: n => `${n} bloqué${n > 1 ? 's' : ''}`,
    lead: 'En plus du filtrage adulte imposé. Ça ne fait que resserrer — retirer un blocage demande une confirmation.',
    groups: {
      gambling: 'Jeux d’argent',
      dating: 'Rencontres',
      social: 'Réseaux sociaux',
      gaming: 'Jeux vidéo'
    },
    domainPlaceholder: 'Bloquer un site (ex. tinder.com)',
    add: 'Bloquer',
    remove: 'Retirer',
    confirmRemove: 'Retirer ce blocage ? Tu desserres ton verrou.'
  },

  weaningPicker: {
    label: 'Rythme de sevrage',
    locked7: 'Verrouillé 7 j/7',
    someDays: n => `${n} j/7`,
    pendingChange: left => <>Changement prévu dans <b>{left}</b> — d’ici là, tes jours actuels restent verrouillés.</>,
    dayState: (full, locked) => `${full} — ${locked ? 'verrouillé' : 'ouvert'}`,
    adviceAll: 'Sept jours sur sept. Il n’y a plus un seul soir où négocier avec toi-même.',
    adviceWeekend: `Le week-end est le moment le plus risqué : plus de temps
                    libre, plus de solitude. Si tu dois laisser un jour ouvert,
                    prends plutôt un jour de semaine chargé.`,
    adviceMin: `Tu es au minimum. Vise un jour de plus d’ici deux semaines :
                c’est le rythme qui tient sur la durée.`,
    adviceOpen: n => `${n} jour${n > 1 ? 's' : ''} encore ouvert${n > 1 ? 's' : ''}.`,
    note: (floor, hours) => <>Plancher atteint : <b>{floor} jours</b>, on ne redescend pas en dessous. Ajouter un jour prend effet <b>tout de suite</b> ; en retirer un attend <b>{hours} heures</b> — une envie de desserrer ne survit pas à une nuit.</>,
    request: hours => `Demander (${hours} h)`,
    apply: 'Appliquer',
    minDays: n => `Minimum ${n} jours.`,
    hoursShort: (h, m) => `${h} h ${m}`,
    minutesShort: m => `${m} min`
  },

  schedules: {
    label: 'Couper Internet',
    add: '+ Ajouter une coupure',
    summaryNone: 'Aucune',
    summaryCount: n => `${n} coupure${n > 1 ? 's' : ''}`,
    tzNote: tz => `Heures dans ton fuseau (${tz}) — modifiable dans « Mon compte ».`,
    none: 'Aucune coupure programmée. Les rechutes arrivent entre 23h et 7h.',
    noneNote: `Concentre ton sommeil : l’écran éteint à heure fixe, c’est
               l’endormissement qui revient et les heures creuses qui
               disparaissent.`,
    everyDay: 'Tous les jours',
    remove: 'Supprimer',
    formNote: (start, end) => `Couper Internet de ${start} à ${end} sur tous les appareils du profil.`,
    nameLabel: 'Nom de la coupure',
    namePlaceholder: 'Nuit',
    defaultName: 'Nuit',
    from: 'De',
    to: 'À',
    pickDay: 'Choisis au moins un jour.',
    create: 'Créer'
  },

  download: {
    mac: 'Télécharger pour Mac',
    macSub: 'Puce Apple (M1–M4) · macOS 11+',
    oldMac: 'Un Mac Intel plus ancien ?',
    macIntel: 'Télécharger — version Intel',
    macIntelSub: 'Processeur Intel · macOS 11+',
    win: 'Télécharger pour Windows',
    winSub: 'Windows 10 / 11 · 64 bits'
  },

  installModal: {
    v2: { copy: 'Touche pour copier', copied: 'Copié ✓', forProfile: n => `Profil · ${n}` },
    title: name => `Verrouiller un appareil · ${name}`,
    tab1: '1 · Superviser',
    tab2: '2 · Filtrer',
    superviseLead: <>Sur ton ordinateur, ouvre l’app <b>SELFCNTRL Superviseur</b>, branche l’iPhone, puis saisis ce code. C’est cette étape qui rend le blocage impossible à retirer.</>,
    generatingCode: 'Génération du code…',
    codeWarn: 'Ce code expire dans 15 minutes et ne sert qu’une fois.',
    tutorialLink: 'Voir le tutoriel en images',
    filterLead: `Une fois l’iPhone supervisé, scanne ce QR avec son appareil
                 photo pour installer le filtrage.`,
    generatingLink: 'Génération du lien…',
    qrAlt: 'QR d’installation',
    step1: 'Appareil photo de l’iPhone → viser le QR.',
    step2: <>Réglages → Général → <b>VPN et gestion d’appareil</b> → installer.</>,
    openLink: 'Ouvrir le lien',

    // Flux LOCK selon l’appareil — une étape à la fois, on confirme pour avancer.
    pick: 'Quel appareil verrouilles-tu ? Les étapes changent.',
    codeLabel: 'Code d’association',
    filterTitle: 'Installer le filtrage',
    stepN: (i, n) => `Étape ${i} sur ${n}`,
    done: 'C’est fait',
    finish: 'Terminé',
    prev: 'Précédent',
    dlApp: 'Télécharger SELFCNTRL (Windows)',
    dlItunes: 'Installer iTunes (Windows, depuis apple.com)',
    helpTuto: 'Besoin d’aide ? Voir le tutoriel en vidéo',
    ios: [
      { t: 'Ouvre SELFCNTRL sur ton ordinateur', p: 'Télécharge SELFCNTRL pour Windows ou Mac, puis ouvre-le. Sur Windows, iTunes est requis (pilotes USB). Garde ton mot de passe Apple à portée.', dl: true, itunes: true },
      { t: 'Branche l’iPhone', p: 'Relie-le au PC en USB et touche « Se fier » sur l’iPhone. Dans SELFCNTRL, son nom doit apparaître. L’app te guide ensuite pour désactiver « Localiser » et la protection en cas de vol.' },
      { t: 'Lance la supervision', p: 'Dans SELFCNTRL, choisis « Superviser un iPhone », entre le code ci-dessous et lance. L’iPhone redémarre une fois — rien n’est effacé.', code: true },
      { t: 'Remets tes protections', p: 'Réactive « Localiser » et la protection en cas de vol. La supervision reste active quoi qu’il arrive.' },
      { t: 'Installe le filtrage', p: 'Scanne le code ci-dessous avec l’appareil photo de l’iPhone, puis Réglages → Général → VPN et gestion d’appareil → installer.', qr: true }
    ],
    win: [
      { t: 'Télécharge SELFCNTRL', p: 'Télécharge SELFCNTRL ci-dessous, dézippe le dossier et ouvre SELFCNTRL.exe sur ce PC.', dl: true },
      { t: 'Choisis « Protéger cet ordinateur »', p: 'Lance l’app — elle demande les droits administrateur — et choisis « Protéger cet ordinateur ».' },
      { t: 'Entre le code', p: 'Entre le code ci-dessous quand l’app le demande. Aucun profil à scanner sur Windows.', code: true }
    ],
    mac: [
      { t: 'Télécharge SELFCNTRL', p: 'Prends la version pour ta puce ci-dessous (Apple Silicon ou Intel), double-clique le .tar.gz pour l’extraire, puis double-clique SELFCNTRL.app. macOS confirme une fois « téléchargée depuis Internet » → « Ouvrir ».', dl: true },
      { t: 'Choisis « Protect this Mac »', p: 'Dans l’app, choisis « Protect this Mac ». Elle prépare le profil de filtrage DNS (Cloudflare) protégé par ton mot de passe de retrait.' },
      { t: 'Entre le code', p: 'Entre le code ci-dessous quand l’app le demande.', code: true },
      { t: 'Approuve le profil', p: 'macOS ouvre le profil : va dans Réglages Système → Général → VPN et gestion d’appareil et approuve « SELFCNTRL » pour verrouiller le filtrage.' }
    ],
    macLead: 'L’app de supervision est Windows uniquement pour l’instant — superviser un Mac, ou un iPhone depuis un Mac, n’est pas encore disponible.',
    macLink: 'Voir le tutoriel et la liste d’attente Mac'
  },

  removalModal: {
    foeWon: 'Il a gagné cette manche.',
    foeWarn: 'Va au bout, et c’est lui qui gagne.',
    releasedT: 'Le verrou peut être retiré',
    releasedLead: hours => `Les ${hours} heures sont passées. Voici le mot de passe à saisir sur l’appareil pour désinstaller le profil, dans Réglages → Général → VPN et gestion d’appareil.`,
    releasedWindows: `Sur un PC Windows, ouvre l’appli SELFCNTRL Retirer et saisis ce même mot de passe.`,
    noPassword: `Aucun mot de passe n’est enregistré sur ce compte. Contacte le
                 support pour retirer le profil.`,
    releasedWarn: `Rien ne t’oblige à t’en servir. Beaucoup arrivent jusqu’ici et
                   referment la page — c’est la manche suivante qui compte.`,
    continueAnyway: 'Je continue finalement',
    deleteProfile: 'Supprimer le profil',
    requestedT: 'Demande enregistrée',
    requestedLead: 'Le mot de passe qui désinstalle le verrou te sera donné dans :',
    requestedWarn: `Ce délai est exactement ce que tu es venu chercher. L’envie
                    de tout arrêter passe en une nuit ; une décision réfléchie
                    tient trois jours. Tu peux fermer cette page, le compte à
                    rebours continue.`,
    cancelRequest: 'Annuler ma demande',
    formT: 'Abandonner le défi',
    formLead: hours => <>Retirer ce profil désactive le filtrage sur tous ses appareils. Ton compteur de jours repart de zéro. Le mot de passe de désinstallation ne te sera donné que <b>{hours} heures</b> après cette demande.</>,
    ack: `Je reconnais que j’ai perdu le défi que je m’étais lancé à moi-même,
          et que personne d’autre n’est en cause.`,
    typeLabel: name => `Saisis « ${name} » pour confirmer`,
    startDelay: hours => `Lancer le délai de ${hours} h`,
    keepGoing: 'Je continue'
  },

  rank: {
    ladder: 'L’échelle',
    fromDay1: 'Dès le premier jour',
    fromDays: n => `À partir de ${n} jours`,
    yourRank: 'Ton rang',
    passed: 'Franchi',
    recordT: 'Ton record',
    currentStreak: 'Série en cours',
    bestStreak: 'Meilleure série',
    relapses: 'Rechutes déclarées',
    days: n => `${n} jour${n > 1 ? 's' : ''}`,
    recordNote: <>Une rechute remet le compteur à zéro mais <b>ne touche pas à ton record</b>. Sans ce bouton, le chiffre affiché ne serait que l’âge de ton compte déguisé en performance.</>,
    declareRelapse: 'J’ai rechuté',
    confirmRelapse: `Remettre ton compteur à zéro ?\n\nTon record est conservé.
C’est la seule façon d’avoir un chiffre qui veut dire quelque chose.`,
    leaderboard: 'Classement',
    leave: 'Ne plus participer',
    join: 'Participer',
    optOutT: 'Tu ne participes pas',
    optOutS: `Ton record reste privé. Si tu rejoins le classement, seul le
              pseudonyme que tu choisis est visible — jamais ton prénom ni ton
              e-mail.`,
    share: 'Partager mon record',
    aliasLabel: 'Ton pseudonyme',
    aliasPlaceholder: 'anonyme',
    defaultAlias: 'anonyme',
    aliasHint: 'Lettres, chiffres, point, tiret et espace. Ton prénom réel n’est jamais publié.',
    demoNote: n => <><b>Classement en cours d’ouverture.</b> {n} des profils affichés sont des exemples le temps que les premiers utilisateurs s’inscrivent.</>,
    you: ' · toi',
    demo: ' · exemple',
    dayShort: 'j',
    seeAll: n => `Voir les ${n} →`,
    showLess: 'Réduire'
  },

  goals: {
    title: 'Objectifs',
    emptyLead: 'Le temps que tu récupères doit aller quelque part.',
    lead: 'Ce que tu fais des heures que tu ne perds plus.',
    tabGoals: 'Mes objectifs',
    tabTrack: 'Suivi',
    // Onglet « Suivi » : évolution dans le temps + comparaison par domaine.
    track: {
      lead: 'Où part le temps, semaine après semaine.',
      streakNow: 'Meilleure série en cours',
      streakUnit: n => `${n} sem.`,
      streakRecord: n => n > 0 ? `record ${n}` : 'pas encore de record',
      doneAll: 'Objectifs bouclés',
      doneAllSub: 'depuis le début',
      cntrlAll: 'CNTRL gagnés',
      cntrlAllSub: 'depuis le début',
      weeksTracked: 'Semaines suivies',
      weeksTrackedSub: 'cycles refermés',
      weeklyHeldT: 'Objectifs tenus chaque semaine',
      weeklyHeldV: (held, total) => `${held} sur ${total} tenus`,
      cntrlWeekT: 'CNTRL gagnés chaque semaine',
      cntrlWeekV: n => `${n} au total`,
      evoEmpty: 'Ton suivi se remplit dès ta première « Nouvelle semaine ». Continue — la courbe démarre au prochain cycle.',
      weekTip: (date, held, total, coins) => `${date} — ${held}/${total} tenus · ${coins} CNTRL`,
      domainT: 'Par domaine, cette semaine',
      domainSub: (held, total, comp) => comp > 0
        ? `${held}/${total} tenus · ${comp} bouclés en tout`
        : `${held}/${total} tenus`,
      strong: 'point fort',
      weak: 'à travailler',
      empty: 'Fixe d’abord un objectif ou deux — ton suivi s’affiche ici.'
    },
    newWeek: 'Nouvelle semaine',
    add: 'Ajouter',
    weekDone: 'Semaine bouclée. Remets les compteurs à zéro et remonte la barre.',
    weekProgress: n => `objectif${n > 1 ? 's' : ''} atteint${n > 1 ? 's' : ''} cette semaine.`,
    formTitle: 'Nouvel objectif',
    areaLabel: 'Domaine',
    suggestions: 'Suggestions',
    preview: 'Aperçu',
    goalLabel: 'L’objectif de la semaine',
    goalHint: 'Choisis une suggestion ci-dessus, ou écris la tienne.',
    howMany: 'Combien',
    unit: 'Unité',
    unitPlaceholder: 'séances, pages, min…',
    creating: 'Création…',
    createGoal: 'Créer l’objectif',
    emptyT: 'Choisis ton premier objectif.',
    emptyS: `Arrêter libère deux à trois heures par semaine. Décide maintenant
             où elles vont, pendant que tu es lucide.`,
    emptyCta: 'Fixer un objectif',
    reached: 'Atteint.',
    left: (n, unit) => `Il te reste ${n} ${unit || ''}`.trim(),
    minusOne: 'Retirer un',
    plusOne: 'Ajouter un',
    plusN: n => `Ajouter ${n}`,
    deleteGoal: title => `Supprimer ${title}`,
    confirmDelete: title => `Supprimer « ${title} » ?`,
    confirmReset: 'Remettre tous les compteurs à zéro pour la semaine ?',

    // Récompense (migration 016) : boucler un objectif crédite des CNTRL.
    reward: n => `+${n} CNTRL`,
    rewardHint: n => `Boucle-le, +${n} CNTRL`,
    earnedTag: 'Encaissé',
    // La série : nombre de semaines d'affilée où l'objectif a été tenu.
    streakTitle: n => `${n} ${n > 1 ? 'semaines' : 'semaine'} d’affilée`,
    weekEarned: n => n > 0
      ? `Tu as gagné ${n} CNTRL cette semaine.`
      : 'Boucle un objectif pour gagner tes premiers CNTRL cette semaine.',
    capNote: n => `Au plus ${n} objectifs récompensés par semaine.`,
    toRewards: 'Mes récompenses',
    autoResetNote: 'Les compteurs repartent seuls au début de chaque semaine.',

    // L'historique : les cycles déjà refermés.
    historyShow: 'Voir les semaines passées',
    historyHide: 'Masquer',
    historyTitle: 'Semaines passées',
    historyEmpty: 'Rien encore. Ta première semaine s’archivera ici.',
    histTotals: (done, cycles) => `${done} bouclé${done > 1 ? 's' : ''} sur ${cycles} cycle${cycles > 1 ? 's' : ''}`,
    histCompleted: 'Bouclé',
    histMissed: 'Manqué',
    histWon: n => `+${n}`
  },

  domains: {
    sport: {
      label: 'Sportif',
      hint: 'De l’énergie remise là où elle sert.',
      presets: [
        { title: 'Séances de musculation', target: 3, unit: 'séances' },
        { title: 'Kilomètres courus', target: 20, unit: 'km' },
        { title: 'Minutes de cardio', target: 90, unit: 'min' },
        { title: 'Pompes', target: 300, unit: 'pompes' }
      ]
    },
    addictions: {
      label: 'Addictions',
      hint: 'Le reste de ce qui décide à ta place.',
      presets: [
        { title: 'Jours sans alcool', target: 7, unit: 'jours' },
        { title: 'Jours sans tabac', target: 7, unit: 'jours' },
        { title: 'Jours sans vape ni nicotine', target: 7, unit: 'jours' },
        { title: 'Jours sans cannabis', target: 7, unit: 'jours' },
        { title: 'Jours sans jeux d’argent', target: 7, unit: 'jours' },
        { title: 'Jours sans énergisants', target: 7, unit: 'jours' }
      ]
    },
    lecture: {
      label: 'Lecture',
      hint: 'Le meilleur remplaçant du défilement.',
      presets: [
        { title: 'Pages lues', target: 150, unit: 'pages' },
        { title: 'Chapitres', target: 10, unit: 'chapitres' },
        { title: 'Minutes de lecture le soir', target: 210, unit: 'min' },
        { title: 'Livre terminé', target: 1, unit: 'livre' }
      ]
    },
    personnel: {
      label: 'Personnel',
      hint: 'Le sommeil, les proches, la discipline ordinaire.',
      presets: [
        { title: 'Nuits couché avant 23h', target: 5, unit: 'nuits' },
        { title: 'Journées sans réseaux sociaux', target: 3, unit: 'jours' },
        { title: 'Appels à mes proches', target: 2, unit: 'appels' },
        { title: 'Matins levé sans snooze', target: 6, unit: 'matins' }
      ]
    },
    pro: {
      label: 'Professionnel',
      hint: 'Les heures de vraie concentration, pas les heures assises.',
      presets: [
        { title: 'Heures de travail concentré', target: 20, unit: 'h' },
        { title: 'Sessions sans téléphone', target: 10, unit: 'sessions' },
        { title: 'Cours ou tutoriels terminés', target: 3, unit: 'modules' },
        { title: 'Candidatures envoyées', target: 5, unit: 'envois' }
      ]
    }
  },

  // La page Récompenses de l'espace client. NB : nommée `cntrl` et non
  // `rewards` — `rewards` est déjà pris par la section de la landing, et les
  // deux dictionnaires sont fusionnés (voir locales/index.js).
  cntrl: {
    v2: {
      worth: usd => `Soit ${usd} $ en cartes cadeaux`,
      monthsChip: n => `mois tenu${n > 1 ? 's' : ''}`,
      cardsChip: n => `carte${n > 1 ? 's' : ''} prête${n > 1 ? 's' : ''}`,
      nextK: 'Ta prochaine carte',
      readyK: 'Prête à commander',
      toNext: n => `Encore ${n} CNTRL pour ta prochaine carte de 5 $`,
      readyP: 'Choisis une marque plus bas et passe commande.',
      earnT: 'Comment ta cagnotte monte',
      earnMonth: '+200 CNTRL',
      earnMonthS: 'Chaque mois où le verrou tient',
      earnGoal: '+10 CNTRL',
      earnGoalS: 'Par objectif atteint, jusqu’à 5 par semaine',
      earnGoalCta: 'Mes objectifs',
      allBonus: 'Tu as tous les bonus',
      orderBtn: (n, b, cost) => `Commander ${n} × ${b} · ${cost} CNTRL`,
      lockedBtn: n => `Encore ${n} CNTRL`,
      pickBrand: 'Choisis ta carte',
      empty: 'Rien pour l’instant. Tes premiers 200 CNTRL arrivent après ton premier mois verrouillé.'
    },
    title: 'Récompenses',
    lead: 'Chaque mois tenu, et chaque objectif bouclé, remplit ta cagnotte.',
    balance: 'Ton solde',
    unit: 'CNTRL',
    // L'état du compteur.
    accruingOn: 'Ton compteur tourne.',
    stateOn: 'Compteur actif',
    stateOff: 'Compteur en pause',
    progressT: 'Progression',
    progressNext: n => `+${n} CNTRL bientôt`,
    progressHint: 'Garde le filtre actif — chaque mois tenu fait avancer la barre et ajoute un bonus.',
    giftcard: 'Carte cadeau',
    paused: {
      no_plan: 'Le compteur démarre à ton premier mois payé.',
      trial: 'L’essai ne compte pas : le compteur part au premier mois payé.',
      inactive: 'Compteur en pause : ton abonnement n’est pas actif.',
      filtering_off: 'Verrouille un appareil et ton compteur démarre. 200 CNTRL par mois tenu.',
      lockCta: 'Verrouiller un appareil'
    },
    monthsHeld: n => `${n} mois tenu${n > 1 ? 's' : ''}`,
    nextMilestone: (dans, bonus) =>
      `Encore ${dans} mois pour le palier +${bonus} CNTRL.`,
    noMilestone: 'Tous les paliers sont atteints.',
    cardsAvailable: n => n > 0
      ? `${n} carte${n > 1 ? 's' : ''} de 5 $ disponible${n > 1 ? 's' : ''}`
      : 'Pas encore de carte disponible',
    // La commande.
    orderTitle: 'Commander une carte cadeau',
    orderLead: n => `1 carte = ${n} CNTRL.`,
    brand: 'Enseigne',
    brands: {
      amazon: 'Amazon',
      airbnb: 'Airbnb',
      starbucks: 'Starbucks',
      googleplay: 'Google Play',
      appstore: 'App Store'
    },
    cardsLabel: 'Nombre de cartes',
    orderBtn: 'Passer la commande',
    ordering: 'Envoi…',
    insufficient: 'Solde insuffisant pour cette commande.',
    orderNote: 'Chaque carte est envoyée à la main après vérification. Compte jusqu’à 48 h.',
    ordered: '🎉 Commande enregistrée. Ta carte arrive par e-mail sous peu.',
    // Le grand livre.
    historyTitle: 'Tes mouvements',
    reasons: {
      monthly: 'Mois tenu',
      milestone: 'Palier',
      redeem: 'Carte cadeau',
      goal: 'Objectif bouclé',
      adjust: 'Ajustement',
      promo: 'Bonus'
    },
    empty: 'Aucun mouvement pour l’instant.',
    // Les commandes passées.
    redemptionsTitle: 'Tes commandes',
    status: {
      pending: 'En attente',
      sent: 'Envoyée',
      refused: 'Refusée'
    },
    card: (cards, brand) => `${cards} × ${brand}`,
    justCredited: n => `+${n} CNTRL viennent d’être crédités.`,
    monthsHeldK: 'Mois tenus',
    cardsK: 'Cartes disponibles',
    rateK: 'Taux',
    towardCard: (have, per) => `${have} / ${per} vers ta prochaine carte`,
    monthsToGo: n => `${n} mois restant${n > 1 ? 's' : ''}`,
    toGo: n => `${n} CNTRL à aller chercher`,
    seeAll: n => `Voir les ${n} →`,
    showLess: 'Réduire'
  },

  subscription: {
    yours: 'Ton abonnement',
    v2: {
      noPlan: 'Pas encore de formule',
      trialLine: n => `Essai en cours — encore ${n} jour${n > 1 ? 's' : ''}.`,
      activeLine: 'Se renouvelle tout seul. Résiliable à tout moment, ton verrou reste en place.',
      inactiveLine: 'Ta formule n’est pas active : le verrou et le compteur de CNTRL sont en pause.'
    },
    manage: 'Gérer ou résilier',
    manageMail: 'Résilier sur WhatsApp',
    state: 'État',
    plan: 'Formule',
    trialLeft: 'Essai restant',
    days: n => `${n} jour${n > 1 ? 's' : ''}`,
    labels: {
      trialing: 'Essai en cours',
      active: 'Actif',
      past_due: 'Paiement en attente',
      canceled: 'Résilié',
      none: 'Aucun abonnement'
    },
    planNames: { monthly: 'Mensuel', yearly: 'Annuel', lifetime: 'À vie', none: '—' },
    noneNote: 'Aucun paiement enregistré. Choisis une formule ci-dessous pour commencer.',
    change: 'Changer de formule',
    choose: 'Choisir une formule',
    currentTag: 'Formule actuelle',
    alreadyOn: 'Déjà en cours',
    coveredByLifetime: 'Inclus dans ton offre à vie',
    redirecting: 'Redirection…',
    trialCta: 'S’abonner',
    upgrade: 'Passer à l’annuel',
    payYear: 'S’abonner à l’année',
    upgradeNote: `En passant à l’annuel, pense à résilier ton abonnement mensuel
                  depuis « Gérer ou résilier » — sinon les deux courent en
                  parallèle.`,
    paymentNote: `Le paiement se fait sur une page hébergée par le prestataire :
                  aucune donnée bancaire ne transite par SELFCNTRL. Le libellé
                  sur ton relevé reste discret.`
  },

  account: {
    infoT: 'Informations',
    firstName: 'Prénom',
    email: 'E-mail',
    plan: 'Formule',
    subscription: 'Abonnement',
    memberSince: 'Membre depuis',
    planNames: { monthly: 'Mensuel', yearly: 'Annuel', lifetime: 'À vie', none: '—' },
    statuses: {
      trialing: 'Essai en cours',
      active: 'Actif',
      past_due: 'Paiement en attente',
      canceled: 'Résilié',
      none: 'Aucun'
    },
    tzT: 'Fuseau horaire',
    tzLead: 'Il cale tes coupures Internet et ton sevrage sur ton heure locale. Rempli automatiquement — corrige-le si besoin.',
    tzLabel: 'Ton fuseau',
    tzSaved: 'Enregistré ✓',
    passwordT: 'Mot de passe',
    updated: 'Mot de passe mis à jour.',
    current: 'Mot de passe actuel',
    next: 'Nouveau mot de passe',
    nextHint: 'Les autres appareils connectés seront déconnectés.',

    cancelT: 'Résilier mon abonnement',
    cancelP: `Écris-nous sur WhatsApp : on arrête le prélèvement et on te le
              confirme dans la conversation — en moins de 24 heures.`,
    cancelBtn: 'Résilier sur WhatsApp',
    // Pré-rempli dans WhatsApp, avec l'e-mail du compte pour retrouver
    // l'abonnement dans Stripe sans aller-retour.
    cancelMsg: email => `Bonjour, je souhaite résilier mon abonnement SELFCNTRL.${email ? ` Compte : ${email}` : ''}`,
    cancelKeep: `Ton verrou reste en place. Résilier l’abonnement ne déverrouille
                 pas tes appareils — ça passe par le délai de retrait de 72 h,
                 depuis la page de ton verrou.`
  },

  tutorial: {
    v2: {
      title: 'Installe ton verrou',
      sub: 'Télécharge, suis la vidéo, verrouille. Une dizaine de minutes, une fois par appareil.',
      deviceL: 'Appareil',
      fromL: 'Je le verrouille depuis',
      from: { windows: 'un PC Windows', mac: 'un Mac', none: 'pas d’ordinateur' },
      winGetP: 'Une petite app qui installe le filtre et le service qui le garde actif. Télécharge-la sur ce PC.',
      winWarnT: 'Windows affiche un avertissement ?',
      macWarnT: 'macOS demande une confirmation ?',
      listT: 'Étape par étape',
      screenOf: (i, n) => `${i} / ${n}`,
      wzGetK: 'Avant de commencer',
      wzVideo: 'Voir en vidéo',
      wzStart: 'C’est bon, on y va →',
      wzLast: 'Fait, dernière vérif →',
      phoneT: 'Tu es sur ton téléphone',
      phoneP: 'Cette installation se fait sur l’ordinateur lui-même. Envoie-toi cette page et ouvre-la dessus.',
      phonePi: 'L’iPhone se verrouille depuis un ordinateur, avec un câble. Envoie-toi cette page et ouvre-la dessus.',
      send: 'Envoyer sur mon ordi',
      copied: 'Lien copié ✓',
      nextStep: 'Fait, étape suivante →',
      undoShort: 'Pas encore fait',
      progress: (d, n) => `${d} / ${n} faites`,
      markDone: 'Fait',
      undo: 'Marquer comme pas fait',
      reset: 'Recommencer',
      allDone: 'Tout est coché. Vérifie que l’appareil affiche « Verrouillé » dans Mon verrou.',
      lockT: 'Vérifie que c’est verrouillé',
      lockP: 'Ouvre Mon verrou : l’appareil affiche « Verrouillé ». Ton compteur de jours démarre à ce moment-là.',
      helpT: 'Bloqué sur une étape ?',
      helpP: 'Écris-nous sur WhatsApp. On répond en moins d’une heure, de 9 h à 23 h.',
      winGetT: 'Télécharge SELFCNTRL pour Windows'
    },
    title: 'Tutoriel',
    subtitle: 'L’installation complète, en vidéo. Compte une dizaine de minutes.',
    writtenT: 'Étape par étape',
    flow: ['Choisis l’appareil', 'Regarde la vidéo', 'Verrouille'],
    flowMin: '≈ 10 min',
    nextStepBtn: 'Étape suivante',
    gotIt: 'Compris',
    lead: `Trois parties : créer ton profil, verrouiller l’iPhone depuis ton
           ordinateur, puis régler ton rythme. Seule la deuxième demande un
           câble — et elle ne se fait qu’une fois. Fais défiler chaque partie
           étape par étape ; clique sur une capture pour l’agrandir.`,
    step: n => `Étape ${n}`,
    stepOf: (i, n) => `Étape ${i} sur ${n}`,
    prevStep: 'Étape précédente',
    nextStep: 'Étape suivante',
    stepsOf: title => `Étapes — ${title}`,
    zoom: caption => `Agrandir : ${caption}`,
    enlarge: 'Appuyer pour agrandir',

    getT: 'Télécharger l’app Superviseur',
    getP: `La partie 2 se fait depuis ton ordinateur, pas depuis ton téléphone.
           Télécharge-la maintenant : tu en auras besoin, avec un câble, dans
           trois minutes.`,
    getWin: 'Télécharger pour Windows',
    getWinSub: 'Installateur · 85 Mo · Windows 10 et 11, 64 bits',
    getPortable: 'Version portable (sans installation)',
    getMacArm: 'Télécharger — puce Apple (M1–M4)',
    getMacIntel: 'Télécharger — Mac Intel',
    getMacArmSub: 'Apple Silicon · 44 Mo · macOS 11 et plus',
    getMacIntelSub: 'Processeur Intel · 46 Mo · macOS 11 et plus',
    macChipHint: 'Quelle version choisir ? Menu Pomme  ▸ À propos de ce Mac : « Puce » = Apple Silicon, « Processeur » = Intel.',
    macGetT: 'Télécharger SELFCNTRL pour Mac',
    macGetP: `Une seule app pour tout : protéger ce Mac (filtrage DNS Cloudflare)
              ou superviser un iPhone branché en USB. Prends la version qui
              correspond à ta puce.`,
    macGetWarn: `App signée par Apple (Developer ID) et notarisée : double-clique
                 SELFCNTRL.app pour l’ouvrir. macOS demande une seule confirmation
                 la première fois (« téléchargée depuis Internet ») → « Ouvrir ».`,
    macSteps: [
      { t: 'Télécharge et ouvre SELFCNTRL', p: 'Prends la version pour ta puce ci-dessus, double-clique le .tar.gz pour l’extraire, puis double-clique SELFCNTRL.app. macOS confirme une fois « téléchargée depuis Internet » → « Ouvrir ».' },
      { t: 'Choisis ton action', p: '« Protect this Mac » installe le filtrage DNS Cloudflare sur le Mac lui-même. « Supervise iPhone » passe un iPhone branché en USB en mode supervisé — il redémarre une fois, et « Localiser » doit être coupé avant.' },
      { t: 'Entre ton code d’association', p: 'Récupère-le dans ton espace SELFCNTRL ▸ Appareils (format ABCD-2345) et saisis-le quand l’app le demande.' },
      { t: 'Approuve le profil', p: 'Pour le Mac, macOS ouvre le profil : Réglages Système ▸ Général ▸ VPN et gestion d’appareil ▸ approuve « SELFCNTRL ». Le retrait est protégé par ton mot de passe.' }
    ],
    getWarn: `L’app n’est pas encore signée, Windows peut donc afficher deux choses.
              Écran BLEU « Éditeur inconnu » : clique « Informations complémentaires »
              puis « Exécuter quand même ». Si à la place une fenêtre dit « Le Contrôle
              intelligent des applications a bloqué une application… » sans aucun bouton
              pour lancer, c’est Smart App Control : sur TON PC uniquement, désactive-le
              dans Sécurité Windows → Contrôle des applications et du navigateur →
              Contrôle intelligent des applications → Désactivé, puis relance le fichier.`,
    troubleT: 'Ça coince',
    troubleLead: 'Les blocages qu’on nous signale.',
    endP: `Bloqué sur une étape ? Écris-nous, on répond en moins d’une heure
           entre 9 h et 23 h.`,
    endLock: 'Aller à mon verrou',
    endWrite: 'Nous écrire',
    parts: [
      {
        id: 'preparer',
        n: '01',
        title: 'Préparer',
        lead: 'Deux minutes sur le site. Rien ne touche encore à ton téléphone.',
        steps: [
          {
            t: 'Repérer ton espace',
            p: `C'est le tableau de bord. Tant qu'aucun appareil n'est
                verrouillé, le bandeau du haut te le dit franchement — il ne
                prétendra jamais que tu es protégé alors que tu ne l'es pas.`,
            shot: ['site-2-espace.png', 'La vue d’ensemble', 'wide']
          },
          {
            t: 'Créer ton profil',
            p: `Va dans « Mon verrou » et clique sur « Ajouter un profil ».
                Donne-lui le nom que tu veux — la plupart des gens n'en ont
                qu'un seul.`,
            shot: ['site-3-creer-profil.png', 'Le formulaire de création', 'wide'],
            note: `Un profil réunit un niveau de filtrage, des horaires de
                   coupure et les appareils qui le portent.`
          },
          {
            t: 'Ce que contient un profil',
            p: `Le filtrage est strict et ne se règle pas : pornographie,
                nudité et thèmes adultes bloqués en continu. En dessous
                viennent le rythme de sevrage, les appareils, et les coupures
                d'internet.`,
            shot: ['site-4-profil.png', 'Une carte profil complète', 'tall']
          }
        ]
      },
      {
        id: 'verrouiller',
        n: '02',
        title: 'Verrouiller l’iPhone',
        lead: `Dix minutes, une seule fois, avec l'iPhone branché à ton
               ordinateur. C'est l'étape qui rend le blocage inarrachable.`,
        steps: [
          {
            t: 'Ouvrir l’app superviseur',
            p: `Télécharge et lance SELFCNTRL Superviseur sur ton PC. Avant de
                commencer, vérifie les trois prérequis qu'elle affiche : le
                câble, iTunes ouvert (la version d'apple.com, pas celle du
                Microsoft Store) et le mot de passe de ton compte Apple.`,
            shot: ['app-01-intro.png', 'L’écran d’accueil de l’app', 'tall']
          },
          {
            t: 'Couper la Protection en cas de vol',
            p: `Sur l'iPhone : Réglages → Face ID et code → Protection en cas
                de vol → désactiver. Si l'iPhone n'a pas de code, passe
                l'étape.`,
            shot: ['app-02-protection.png', 'Étape 2 sur 8', 'tall'],
            note: `C'est temporaire. Tu remets tout en place cinq étapes plus
                   loin, et le mode supervisé reste actif quoi qu'il arrive.`
          },
          {
            t: 'Couper « Localiser »',
            p: `Réglages → ton nom → Localiser → Localiser mon iPhone →
                désactiver. Le mot de passe Apple te sera demandé. Sans ça,
                Apple refuse purement et simplement la supervision.`,
            shot: ['app-03-findmy.png', 'Étape 3 sur 8', 'tall'],
            note: `Temporaire, comme l'étape d'avant. Une fois la supervision
                   terminée, tu réactives Localiser (étape 6) et il remarche
                   exactement comme avant : même compte, mêmes appareils,
                   rien de perdu.`
          },
          {
            t: 'Brancher l’iPhone',
            p: `Connecte-le en USB et touche « Se fier » sur son écran. L'app
                le détecte toute seule : quand son nom et sa version d'iOS
                s'affichent, le bouton s'allume.`,
            shot: ['app-04-plug.png', 'L’appareil est détecté', 'tall'],
            note: `Rien ne se passe ? Utilise le câble d'origine (certains
                   câbles ne font que charger), et vérifie qu'iTunes est bien
                   ouvert.`
          },
          {
            t: 'Lancer la supervision',
            p: `Clique sur « Superviser maintenant » et ne débranche pas.
                L'iPhone redémarre une fois pendant l'opération : c'est normal,
                aucune donnée n'est effacée.`,
            shot: ['app-05-supervise.png', 'Étape 5 sur 8', 'tall'],
            warn: `Fais une sauvegarde au préalable si l'appareil contient des
                   choses auxquelles tu tiens. On n'efface rien, mais une
                   sauvegarde ne coûte rien non plus.`
          },
          {
            t: 'Remettre les protections',
            p: `Réactive Localiser mon iPhone et la Protection en cas de vol.
                L'iPhone peut redemander la connexion à ton compte Apple :
                reconnecte-toi normalement.`,
            shot: ['app-07-protections.png', 'Étape 6 sur 8', 'tall']
          },
          {
            t: 'Récupérer le code sur le site',
            p: `Retourne dans « Mon verrou », clique sur « Verrouiller ». Un
                code de huit caractères s'affiche, valable quinze minutes et
                une seule fois.`,
            shot: ['site-7-code.png', 'Le code d’association', 'tall']
          },
          {
            t: 'Rattacher l’appareil',
            p: `Recopie le code dans l'app, puis valide. L'iPhone est
                maintenant lié à ton compte.`,
            shot: ['app-08-pair.png', 'Étape 7 sur 8', 'tall'],
            note: `Code expiré ? Ferme la fenêtre sur le site et reclique sur
                   « Verrouiller » : un nouveau code est généré.`
          },
          {
            t: 'Installer le filtrage',
            p: `Dans la même fenêtre du site, passe sur l'onglet « 2 · Filtrer »
                et vise le QR code avec l'appareil photo de l'iPhone. Le profil
                se télécharge, puis s'installe dans Réglages → Général → VPN et
                gestion d'appareil.`,
            shot: ['site-8-qr.png', 'Le QR d’installation', 'tall'],
            note: `iOS affichera « Non vérifié » : c'est normal, le profil n'est
                   pas signé par Apple. Installe-le quand même.`
          },
          {
            t: 'C’est verrouillé',
            p: `L'app annonce que l'appareil est rattaché et supervisé. Tu peux
                la fermer : elle ne sert plus à rien tant que tu n'ajoutes pas
                un autre appareil.`,
            shot: ['app-09-done.png', 'Étape 8 sur 8', 'tall']
          },
          {
            t: 'Le vérifier sur le site',
            p: `L'appareil apparaît tout seul dans la liste du profil, marqué
                « Verrouillé ». Rien à saisir à la main : une ligne écrite à la
                main s'afficherait « Verrouillé » sans que le téléphone le
                soit.`,
            shot: ['site-4b-appareils.png', 'L’appareil dans ton profil', 'wide']
          }
        ]
      },
      {
        id: 'vivre',
        n: '03',
        title: 'Régler, puis vivre avec',
        lead: 'Le verrou est posé. Le reste, c’est ton rythme.',
        steps: [
          {
            t: 'Choisir ton rythme de sevrage',
            p: `Soit tu coupes net, sept jours sur sept. Soit tu montes par
                paliers, en verrouillant d'abord quatre jours par semaine. Dans
                les deux cas tu peux toujours en ajouter — jamais en retirer en
                dessous du palier atteint.`,
            shot: ['site-5-sevrage.png', 'Le sélecteur de jours', 'wide'],
            note: `Une baisse ne s'applique pas tout de suite : elle attend
                   vingt-quatre heures. Un soir de faiblesse ne suffit donc pas
                   à défaire ce que tu as décidé le matin.`
          },
          {
            t: 'Couper internet la nuit',
            p: `Ajoute une plage horaire — 23 h à 7 h, par exemple — et internet
                s'arrête entièrement sur les appareils du profil pendant ce
                créneau. C'est la mesure la plus efficace : presque toutes les
                rechutes arrivent entre minuit et quatre heures.`,
            shot: ['site-6-couvre-feu.png', 'Une coupure programmée', 'wide']
          },
          {
            t: 'Suivre ton rang',
            p: `Le compteur repart du jour où tu as commencé, et huit paliers
                jalonnent la route, de Déchu à Élu. Si tu rechutes, le bouton
                « J'ai rechuté » remet le compteur à zéro — sans ce bouton, le
                chiffre ne voudrait rien dire.`,
            shot: ['site-9-rang.png', 'L’échelle des rangs', 'wide']
          },
          {
            t: 'Te fixer des objectifs',
            p: `Cinq domaines : sportif, addictions, lecture, personnel,
                professionnel. Le temps que tu ne perds plus doit aller quelque
                part — c'est à ça que sert cette page.`,
            shot: ['site-10-objectifs.png', 'La page objectifs', 'wide']
          },
          {
            t: 'Si tu veux tout retirer',
            p: `C'est possible, mais pas dans l'instant. Depuis la carte du
                profil, la demande de retrait ouvre un délai de réflexion de
                soixante-douze heures. Au terme du délai, et seulement là, le
                mot de passe de désinstallation s'affiche.`,
            note: `Le support ne peut pas raccourcir ce délai. Ce n'est pas de
                   la mauvaise volonté : si un message suffisait à l'annuler,
                   le produit n'aurait aucune valeur.`
          }
        ]
      }
    ],
    faq: [
      ['« Aucun iPhone branché »',
       `iTunes doit être installé depuis apple.com et ouvert — la version du
        Microsoft Store n'installe pas le pilote USB. Utilise le câble
        d'origine et pense à toucher « Se fier » sur l'écran du téléphone.`],
      ['« La supervision a échoué »',
       `Neuf fois sur dix, Localiser mon iPhone est resté actif, ou la
        Protection en cas de vol n'a pas été coupée. Reprends les deux étapes
        de préparation, puis réessaie.`],
      ['Le code d’association ne passe pas',
       `Il expire au bout de quinze minutes et ne sert qu'une fois. Reclique
        sur « Verrouiller » depuis le site pour en obtenir un nouveau.`],
      ['iOS dit que le profil n’est pas vérifié',
       `Normal : il n'est pas signé par Apple. Ça ne change rien à son
        fonctionnement.`],
      ['Puis-je verrouiller plusieurs appareils ?',
       `Oui. Répète la partie 2 pour chacun ; ils se rangent tous sous le même
        profil et partagent ses réglages.`],
      ['J’ai désinstallé le profil sans le mot de passe',
       `Alors écris-nous : c'est exactement le pari à 100 $, et il est décrit
        en détail dans la politique de remboursement.`]
    ]
  },

  // Rescapés du dictionnaire de la landing, supprimé le 04/08/2026 : ces
  // clés-là sont lues HORS landing et doivent rester traduites.
  //   nav.home  → DashLayout (libellé du logo)
  //   plans.*   → dashboard/Subscription (les deux cartes de formule)
  //   cookies.* → CookieBanner, monté à l'échelle de l'application
  nav: {
    home: 'SELFCNTRL — accueil'
  },

  plans: {
    monthlyName: 'Mensuel',
    monthlyPrice: '9,99 $',
    monthlyPer: ' / mois',
    monthly: [
      'Tous tes appareils verrouillés',
      'Couvre-feux automatiques la nuit',
      'Résiliable à tout moment'
    ],
    yearlyName: 'Annuel',
    yearlyPrice: '49,99 $',
    yearlyPer: ' / an',
    yearlyOld: '120 $ en mensuel',
    save: <><b>70 $ économisés</b> par rapport au mensuel — environ 4,17 $ par mois.</>,
    yearly: [
      'Tout ce qu’il y a dans le mensuel',
      'Revient à 4,17 $ par mois',
      '30 jours remboursé sans justification'
    ],
    // Badge sur la carte annuelle de la landing (Plans.js). Sans cette clé FR,
    // il retomberait sur l'anglais.
    best: 'Meilleur choix'
  },

  cookies: {
    title: 'Cookies',
    body: `On utilise un cookie de mesure pour savoir quelles publicités
           amènent du monde ici. Rien de ta navigation n’est lu ni conservé.`,
    link: 'Confidentialité',
    accept: 'Accepter',
    refuse: 'Refuser'
  }
}

export default app
